<template>
  <TCard :title="feedback.title" class="feedback-card">
    <template #title-right>
      <scale-button :href="feedback.buttonLink" target="_blank">
        <scale-icon :accessibility-title="feedback.cardIcon" :name="feedback.cardIcon" />
        {{ feedback.buttonText }}
      </scale-button>
    </template>
  </TCard>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n"
import TCard from "@/components/global/TCard/TCard.vue"

const { t } = useI18n()
const feedback = {
  title: t("feedbackCard.title"),
  cardIcon: "send",
  buttonText: t("feedbackCard.contactUs"),
  buttonLink: "mailto:DIH_Support@telekom.de"
}
</script>

<style lang="scss" scoped>
.feedback-card {
  &:deep {
    .t-card--title {
      align-items: center;
    }
  }
}
</style>
